import React, { Component } from 'react';
import _ from 'lodash';
import {
    getSpendbacks as fetchSpendbacks,
    fetchUrl
} from './spendbacksActions';
import {
    getSpendbacks,
    getCount,
    getPages,
    getSpendbacksErrorMessage,
    getIsSpendbacksLoading,
    getHasMore
} from './spendbacksEntity';
import SpendbackStatusFilter from '../Table/Filters/SpendbackStatusFilter/SpendbackStatusFilter';
import SpendbackListItem from './SpendbackListItem/SpendbackListItem';
import { transformDateCell } from '../../utils/cell';
import Table from '../Table/Table';
import {
    dataTransform,
    payoutProviderMapper
} from '@nexio/emvio-util-app';
import PropTypes from 'prop-types';
import { selectSpendback } from './spendbacksActions';
import { getSelectedPayoutAccountIdsString } from '../PayoutAccountSelector/payoutAccountSelectorViewState';
import { getPayoutAccountsMapper } from '../PayoutAccounts/payoutAccountEntity';
import { getColumnsByUniqueTableName } from '../Table/tableEntity';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { getCustomAccess } from '../Self/selfEntity';
import './Spendbacks.scss';
import { getIsUserAnAdmin } from '../UserData/userDataEntity';
import FilterWithMapper from '../Table/Filters/FilterWithMapper/FilterWithMapper';
import CurrencyCodeFilter from '../Table/Filters/CurrencyCodeFilter/CurrencyCodeFilter';
import ColorDollarAmountCell from '../Table/Cells/ColorDollarAmountCell/ColorDollarAmountCell';

export class Spendbacks extends Component {
    dateKey = 'spendbackDate';

    static propTypes = {
        selectedPayoutAccountIds: PropTypes.string,
        columns: PropTypes.array,
        payoutAccountMap: PropTypes.any,
        timezone: PropTypes.string,
        customAccess: PropTypes.any,
        isAdmin: PropTypes.bool
    };

    constructor(props) {
        super(props);

        this.state = {};

        this.defaultColumnsAndProps = [
            {
                accessor: 'amount',
                Cell: (props) => <ColorDollarAmountCell amount={props.value} currencyCode={props.original.currency} />,
                filterable: true,
                className: ['cursor-pointer'],
                label: 'Amount',
                minWidth: 64,
                show: true,
                sortable: false
            },
            {
                accessor: 'currency',
                Filter: ({ filter, onChange }) => (<CurrencyCodeFilter
                    filter={filter}
                    onChange={onChange}
                    allowAllCurrencies
                    shouldUseCurrencyCodeAsValue />
                ),
                className: ['cursor-pointer'],
                label: 'Currency',
                minWidth: 75,
                show: true,
                sortable: false
            },
            {
                accessor: 'country',
                className: ['cursor-pointer'],
                label: 'Country',
                minWidth: 110,
                show: false,
                sortable: true,
                filterable: true
            },
            {
                accessor: 'payoutAccountId',
                transformData: (data) => `${data.original.payoutAccountId} - ${this.props.payoutAccountMap[data.original.payoutAccountId]}`,
                filterable: true,
                Filter: ({ filter, onChange }) => (
                    <FilterWithMapper filter={filter}
                        mapper={this.getPayoutAccountsDropDown()}
                        onChange={onChange}
                    />
                ),
                className: ['cursor-pointer'],
                label: 'Payout Account',
                minWidth: 250,
                show: true,
                sortable: true
            },
            {
                accessor: 'spendbackDate',
                Cell: transformDateCell,
                filterable: false,
                className: ['cursor-pointer'],
                label: 'Spendback Date',
                minWidth: 160,
                show: true,
                transformData: dataTransform.dateTimezoneButHideTimezone,
                transformType: 'dateTimezoneButHideTimezone'
            },
            {
                accessor: 'providerSpendbackRef',
                filterable: true,
                className: ['cursor-pointer'],
                label: 'Provider Spendback Reference',
                minWidth: 230,
                show: true,
                sortable: false
            },
            {
                accessor: 'spendbackRef',
                filterable: true,
                className: ['cursor-pointer'],
                label: 'Spendback Reference',
                minWidth: 170,
                show: true,
                sortable: false
            },
            {
                accessor: 'spendbackStatus',
                transformData: dataTransform.spendbackStatusMapper,
                Filter: ({ filter, onChange }) => (
                    <SpendbackStatusFilter
                        filter={filter}
                        onChange={onChange}
                    />
                ),
                filterable: true,
                className: ['cursor-pointer'],
                label: 'Spendback Status',
                minWidth: 135,
                show: true,
                sortable: false
            },
            {
                accessor: 'providerId',
                filterable: true,
                className: ['cursor-pointer'],
                label: 'Provider ID',
                minWidth: 90,
                show: true,
                sortable: false
            },
            {
                accessor: 'recipientId',
                filterable: true,
                className: ['cursor-pointer'],
                label: 'Recipient ID',
                minWidth: 90,
                show: true,
                sortable: false
            },
            {
                accessor: 'recipientRef',
                filterable: true,
                className: ['cursor-pointer'],
                label: 'Recipient Reference',
                minWidth: 150,
                show: true,
                sortable: false
            },
            {
                accessor: 'providerType',
                label: 'Spendback Provider Name',
                transformData: dataTransform.payoutProviderMapper,
                Filter: ({ filter, onChange }) => (
                    <FilterWithMapper
                        filter={filter}
                        mapper={payoutProviderMapper}
                        onChange={onChange}
                    />
                ),
                filterable: true,
                className: ['cursor-pointer'],
                minWidth: 190,
                show: true,
                sortable: false
            },
            {
                accessor: 'description',
                className: ['cursor-pointer'],
                label: 'Description',
                minWidth: 140,
                show: false
            }
        ];
    }

    getTableState = (tableState) => {
        this.setState({
            ...tableState
        });
    };

    getPayoutAccountsDropDown = () => {
        const result = {};
        _.forEach(this.props.payoutAccountMap, (value, key) => {
            result[key] = `${key} - ${value}`;
        });

        return result;
    };

    render() {

        return (
            <div className="emvio-spendbacks">
                <Table
                    fetchUrl={fetchUrl}
                    className="emvio-spendbacks-table"
                    dateKey={this.dateKey}
                    defaultColumnsAndProps={this.defaultColumnsAndProps}
                    defaultSorted={[{
                        desc: true,
                        id: this.dateKey
                    }]}
                    fetchData={(filters, page, pageSize, sorters, merchantIds, columns) => fetchSpendbacks(filters, page, pageSize, sorters, this.props.selectedPayoutAccountIds, columns)}
                    countSelector={getCount}
                    dataSelector={getSpendbacks}
                    selectRow={selectSpendback}
                    errorMessageSelector={getSpendbacksErrorMessage}
                    isDataLoadingSelector={getIsSpendbacksLoading}
                    pagesSelector={getPages}
                    itemKey="id"
                    hasNoCount={true}
                    HeaderComponent={this.renderHeaderComponent}
                    ListItemComponent={SpendbackListItem}
                    noDataText="No Spendbacks Found"
                    uniqueTableName="Spendbacks"
                    getTableState={this.getTableState}
                    hasMoreSelector={getHasMore}
                    filterable={true}
                />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        selectedPayoutAccountIds: getSelectedPayoutAccountIdsString(state),
        columns: getColumnsByUniqueTableName(state, 'Spendbacks'),
        payoutAccountMap: getPayoutAccountsMapper(state),
        customAccess: getCustomAccess(state),
        isAdmin: getIsUserAnAdmin(state)
    };
}

export default withRouter(connect(mapStateToProps)(Spendbacks));
